import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MissingLetters.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.MissingLetters.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.word = [];
  this.texts = [];
  this.answers = [];
};

EDC.Games.MissingLetters.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.MissingLetters.Scenes.Main.prototype.constructor = EDC.Games.MissingLetters.Scenes.Main;

const ML = EDC.Games.MissingLetters.Scenes.Main.prototype;

ML.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

ML.createTemplateUI = function () {
  // const titleFont = {
  //   font: `${this.gameConfig.titleSize} ${this.gameConfig.font}`,
  // };
  // const title = this.add.text(
  //   this.game.config.width / 2,
  //   100,
  //   this.gameConfig.titleTxt,
  //   titleFont,
  // ).setOrigin(0.5);
  // const frame = this.add.sprite(
  //  this.game.config.width / 2, 960, 'instructions-frame').setOrigin(0.5);
  // const instructions = this.make.text({
  //   x: this.game.config.width / 2,
  //   y: 960,
  //   text: this.gameConfig.instructionsTxt,
  //   origin: { x: 0.5, y: 0.5 },
  //   style: {
  //     fontFamily: `${this.gameConfig.font}`,
  //     fontSize: `${this.gameConfig.instructionsSize}`,
  //     wordWrap: { width: 1250 },
  //     align: 'center',
  //     lineSpacing: 15,
  //   },
  // });
};

ML.loadIteration = function () {
  this.createWord();
  this.createAnswers();
};

ML.createAnswers = function () {
  const { word } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { missing } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `${this.gameConfig.questionSize} ${this.gameConfig.questionFont}`,
  };
  const letters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];
  const missingLetter = word[missing - 1];
  const missingKey = letters.indexOf(missingLetter);
  let keys = [];
  keys.push(missingKey);
  for (let i = 0; i < 3; i++) {
    const key = Math.floor(Math.random() * 26);
    if (keys.indexOf(key) !== -1) {
      i -= 1;
    } else {
      keys.push(key);
    }
  }
  keys = this.shuffle(keys);
  for (let i = 0; i < keys.length; i++) {
    const coordinate = this.getAnswerPosition(i);
    const container = this.add.container(coordinate.x, coordinate.y);
    const text = this.add.text(0, 0, letters[keys[i]], font).setOrigin(0.5);
    this.texts.push(text);
    container.add(text);
    container.setSize(260, 290);
    if (keys[i] === missingKey) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    this.startShakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.answers.push(container);
  }
};

ML.getAnswerPosition = function (index) {
  const positions = {
    0: { x: 460, y: 690 },
    1: { x: 910, y: 610 },
    2: { x: 1350, y: 660 },
    3: { x: 1730, y: 790 },
  };
  return positions[index];
};

ML.checkAnswer = function (answer) {
  if (answer.isCorrect) {
    this.playCorrect();
    this.answers.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
    });
    this.flashAnswer(answer);
    answer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2500, this.nextIteration, [], this);
  } else {
    answer.first.setTint(0xff0000);
    answer.shakeAnim.stop();
    answer.angle = 0;
    answer.disableInteractive();
    this.playWrong();
    answer.getData('markAnim').showMark(false, () => {});
  }
};

ML.flashAnswer = function (answer) {
  const font = {
    font: `${this.gameConfig.questionSize} ${this.gameConfig.questionFont}`,
  };
  const letter = answer.first.text;
  const container = this.add.container(0, 0).setAlpha(0.1);
  const sprite = this.add.sprite(0, 0, 'box-normal');
  const text = this.add.text(0, -15, letter, font).setOrigin(0.5);
  container.add(sprite);
  container.add(text);
  const target = this.word.filter(x => x.toFlash);
  container.x = target[0].x;
  container.y = target[0].y;
  this.tweens.add({
    targets: container,
    alpha: 1,
    duration: 500,
    ease: 'Sine.easeInOut',
    yoyo: false,
  });
  target[0].destroy();
  this.word.push(container);
};

ML.nextIteration = function () {
  this.answers.map(x => x.destroy());
  this.answers = [];
  this.word.map(x => x.destroy());
  this.word = [];
  this.texts = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

ML.shuffle = function (array) {
  let j;
  let x;
  let i;
  for (i = array.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = array[i];
    array[i] = array[j];
    array[j] = x;
  }
  return array;
};

ML.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

ML.createWord = function () {
  const { word } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { missing } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `${this.gameConfig.questionSize} ${this.gameConfig.questionFont}`,
  };
  const array = [];
  for (let i = 0; i < word.length; i++) {
    array.push(word[i]);
  }
  for (let i = 0; i < array.length; i++) {
    const container = this.add.container(0, 320);
    if (i === missing - 1) {
      const sprite = this.add.sprite(0, 0, 'box-missing');
      container.add(sprite);
      container.toFlash = true;
      this.scaleAnimation(container);
    } else {
      const sprite = this.add.sprite(0, 0, 'box-normal');
      const text = this.add.text(0, -15, array[i], font).setOrigin(0.5);
      this.texts.push(text);
      container.add(sprite);
      container.add(text);
      container.toFlash = false;
    }
    container.setSize(180, 260);
    this.word.push(container);
  }
  this.adjustPosition(this.word);
};

ML.update = function () {
  this.texts.map(x => x.updateText());
};

ML.adjustPosition = function (array) {
  const width = array.length * array[0].displayWidth;
  const startingX = (this.game.config.width - width) / 2 - 30;
  for (let i = 0; i < array.length; i++) {
    array[i].x = startingX + (array[0].displayWidth + 30) * i;
    array[i].init_X = array[i].x;
  }
};

ML.backToStart = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.startShakeAnimation.bind(this, choice),
  });
};

ML.startShakeAnimation = function (choice) {
  const repeats = 5;
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 1,
    ease: 'Linear',
    yoyo: false,
    delay: 6000,
    onActive: this.moveRight.bind(this, choice, repeats),
  });
};

ML.moveRight = function (choice, repeats) {
  repeats -= 1;
  if (repeats < 0) {
    this.backToStart(choice);
  } else {
    choice.shakeAnim = this.tweens.add({
      targets: choice,
      angle: 2,
      duration: 100,
      ease: 'Sine.easeInOut',
      yoyo: false,
      onComplete: this.moveLeft.bind(this, choice, repeats),
    });
  }
};

ML.moveLeft = function (choice, repeats) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: -2,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.moveRight.bind(this, choice, repeats),
  });
};

export default EDC.Games.MissingLetters.Scenes.Main;
